import { graphql } from 'react-relay';

export const cutOffTableFragment = graphql`
    fragment CutOffTable_table on CutOffTable {
        entries( first: 1000) {
            edges {
                node {
                    id
                    name
                    isin
                    currency
                    frequency
                    frequencyComment
                    cutOffTime
                    valueDate
                    salesAdmission
                }
            }
        }
        ...CutOffTableHeader_header
    }
`;
